var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui-radio', {active: _vm.active}]},[_c('span',{staticClass:"ui-radio__radio"}),_vm._v(" "),_c('span',{staticClass:"ui-radio__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }